import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { welcomeMessages as messages } from './welcomeMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole welcome page; each part uses its own slice of it */
import styles from './WelcomeView.module.scss';
/* eslint-enable css-modules/no-unused-class */

const NAME_INPUT_ID = 'welcome-artist-name';
const NAME_HINT_ID = 'welcome-artist-name-hint';

interface ArtistNameFieldProps {
  name: string;
  setName: (value: string) => void;
  disabled: boolean;
  /** True while the field is empty: a hint under it says why the buttons are off. */
  needsName: boolean;
}

/** "Your artist name" (design: onboarding a1, `.ob-lbl` + `.ob-in`). */
const ArtistNameFieldComponent: React.FC<ArtistNameFieldProps> = ({ name, setName, disabled, needsName }) => {
  const intl = useIntl();
  return (
    <div className={styles.field}>
      <label className={styles.label} htmlFor={NAME_INPUT_ID}>
        {intl.formatMessage(messages.nameLabel)}
        <span className={styles.labelHint}>{intl.formatMessage(messages.nameHint)}</span>
      </label>
      <div className={styles.input}>
        <input
          id={NAME_INPUT_ID}
          value={name}
          onChange={(event) => setName(event.target.value)}
          placeholder={intl.formatMessage(messages.namePlaceholder)}
          aria-describedby={needsName ? NAME_HINT_ID : undefined}
          maxLength={80}
          autoComplete="off"
          disabled={disabled}
          // The page asks one question only, so the field takes the focus.
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
        />
      </div>
      {needsName ? (
        <p id={NAME_HINT_ID} className={styles.hint}>
          {intl.formatMessage(messages.nameRequired)}
        </p>
      ) : null}
    </div>
  );
};

export const ArtistNameField = TypedMemo(ArtistNameFieldComponent);
